import { render, staticRenderFns } from "./HubTotal.vue?vue&type=template&id=f24f2572&lang=pug&"
import script from "./HubTotal.vue?vue&type=script&lang=ts&"
export * from "./HubTotal.vue?vue&type=script&lang=ts&"
import style0 from "./HubTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports